export default __webpack_public_path__ + "d35858f107ed5c6372b431d16adbf028.svg";